/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InteractionsInputs */

const en_interactions = /** @type {(inputs: InteractionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactions`)
};

const de_interactions = /** @type {(inputs: InteractionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interaktionen`)
};

/**
* | output |
* | --- |
* | "Interactions" |
*
* @param {InteractionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interactions = /** @type {((inputs?: InteractionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InteractionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_interactions(inputs)
	return de_interactions(inputs)
});